"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.graphql = exports.fetchWithAuth = void 0;
const rest_modules_1 = require("@wix/sdk-runtime/rest-modules");
exports.fetchWithAuth = (0, rest_modules_1.createRESTModule)((restModuleOpts) => {
    return ((url, options) => restModuleOpts.fetchWithAuth(url, options));
});
exports.graphql = (0, rest_modules_1.createRESTModule)(((restModuleOpts) => {
    // eslint-disable-next-line @typescript-eslint/no-shadow
    return async function graphql(query, variables, opts = {
        apiVersion: 'alpha',
    }) {
        const result = await restModuleOpts.request(({ host }) => {
            const basePath = host === 'www.wixapis.com' ? '/graphql' : '/_api/graphql';
            return {
                method: 'POST',
                url: `${basePath}/${opts.apiVersion}`,
                data: { query, variables },
                packageName: '@wix/essentials',
            };
        });
        return result.data;
    };
}));
